let pipelinesQueryParams;
export function setPipelinesQueryParams(queryParams) {
    pipelinesQueryParams = queryParams;
}
export function getPipelinesQueryParams() {
    return pipelinesQueryParams;
}
//# sourceMappingURL=pipelines-query-params.js.map